import Tabs from '@/components/ui/tabs';
import { ComponentMissionTabs } from '@edwin-group/cj-graphql';
import { useMemo } from 'react';

export enum TabsListingEnum {
  MISSIONS = 'missions',
  PROGRAMMES = 'programmes',
}

export const TabsListing = ({
  tabsListPage,
  currentTab,
  setCurrentTab,
}: {
  currentTab: TabsListingEnum;
  setCurrentTab: (tab: TabsListingEnum) => void;
  tabsListPage?: ComponentMissionTabs | undefined | null;
}) => {
  const tabs = useMemo(() => {
    return [
      {
        name: tabsListPage?.allTab || 'All',
        current: currentTab === TabsListingEnum.MISSIONS,
        onClick: () => setCurrentTab(TabsListingEnum.MISSIONS),
      },
      {
        name: tabsListPage?.yourProgrammesTab || 'Programmes',
        current: currentTab === TabsListingEnum.PROGRAMMES,
        onClick: () => setCurrentTab(TabsListingEnum.PROGRAMMES),
      },
    ];
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentTab, tabsListPage]);
  return <Tabs tabs={tabs} />;
};
